var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20,22H2c-1.10254,0-2-.89746-2-2V2C0,.89697.89746,0,2,0h18c1.10254,0,2,.89697,2,2v18c0,1.10254-.89746,2-2,2ZM2,2h-.00098l.00098,18h18V2H2Z",
    fill: "#262626",
    strokeWidth: 0
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.57038,14.49265c-1.20099-1.03656-1.20111-1.09259-1.71875-1.65875-.57019-.61493-1.14349-1.22131-1.7207-1.82135,1.14783-1.16394,2.27039-2.35162,3.36462-3.58209,1.177-1.32501-.81-3.25897-2-1.92499-1.07916,1.21149-2.18567,2.38-3.31519,3.52618-1.21667-1.20514-2.46075-2.38049-3.74976-3.52679-1.32495-1.17694-3.25897.81006-1.92499,2,1.27246,1.13354,2.49969,2.29523,3.70099,3.48438-.67157.64996-1.35052,1.29547-2.0401,1.93719l-1.58374,1.6438c-1.31195,1.21399.62201,3.20599,1.92505,2,1.0365-1.20099,1.09253-1.20111,1.65869-1.71875.67322-.62421,1.33624-1.25226,1.99158-1.88513.59314.61517,1.18207,1.23737,1.76855,1.86755l1.64374,1.58374c1.21399,1.31201,3.20599-.62201,2-1.92499Z",
    fill: "red",
    strokeWidth: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocRejected);
export default __webpack_public_path__ + "static/media/doc_rejected.538b942aa6b2b1e955c89de8976bd793.svg";
export { ForwardRef as ReactComponent };